var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"content-container flex flex-col w-full h-full items-center justify-center px-8"},[_c('Header1',{attrs:{"label":"Registrieren"}}),_c('div',{staticClass:"container flex flex-col items-center"},[_c('RegisterTabs')],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }